import { Component } from '@angular/core';

import { MobilePagesService } from '../../services/pages.service';

@Component({
  template: '',
})
export class MobileLandingPageComponent {
  landingPage$ = this.pagesService.landingPage$;

  activeIndex: string;

  constructor(protected pagesService: MobilePagesService) {}

  toggleAccordion(index: string) {
    this.activeIndex = this.activeIndex === index ? null : index;
  }

  ngOnDestroy() {
    this.pagesService.landingPage$ = null;
  }
}
